import { create } from 'zustand';
import api from '../api/axios';

export interface Kid {
  id: number;
  name: string;
  username: string;
  grade: number;
  avatar?: string | null;
  profilePhotoUrl?: string | null;
}

interface KidsState {
  kids: Kid[];
  loading: boolean;
  fetchKids: () => Promise<void>;
}

// Shared so the parent sidebar and pages stay in sync after add/remove.
const useKidsStore = create<KidsState>((set) => ({
  kids: [],
  loading: false,
  fetchKids: async () => {
    set({ loading: true });
    try {
      const res = await api.get('/api/parent/kids');
      set({ kids: res.data });
    } catch {
      // leave existing list on error
    } finally {
      set({ loading: false });
    }
  },
}));

export default useKidsStore;
